import React, { useState } from "react";
import "./EditCategoryPopup.css";
import cross from "../../../../../Assets/cross.svg";
import { useSelector } from "react-redux";

const EditCategoryPopup = ({ activeCategory, onUpdate, onClose }) => {
  const [newCategoryName, setNewCategoryName] = useState(activeCategory);
  const [error, setError] = useState("");
  const CategoriesList = useSelector((state) => state.order.newCategories);

  const handleInputChange = (event) => {
    const input = event.target.value;
    setNewCategoryName(input); // Allow all characters while typing
    setError(""); // Clear error on input change
  };

  const handleSubmit = () => {
    if (!newCategoryName.trim()) {
      setError("Category name cannot be empty");
      return;
    }
    if (/\s{2,}/.test(newCategoryName)) {
      setError("category can't contains multiple spaces.");
      return;
    }

    if (
      newCategoryName.trim() !== activeCategory &&
      Object.values(CategoriesList).some(
        (category) =>
          typeof category === "string" &&
          category.toLowerCase() === newCategoryName.trim().toLowerCase()
      )
    ) {
      setError("Category Present");
      return;
    }
    onUpdate(newCategoryName.trim()); // Call the update function from the parent
    onClose(); // Close the popup
  };

  

  return (
    <div className="edit-category-popup">
      <div className="popup-content">
        <button className="close" onClick={onClose}>
          <img src={cross} alt="cross" />
        </button>
        <div className="input-group">
          <label>Category Name</label>
          <input
            type="text"
            value={newCategoryName}
            onChange={handleInputChange}
            placeholder="Enter a CatagoryName"
            maxLength={42}
            style={error ? { border: "1px solid red" } : {}}
          />
          {error && <span className="error-message">{error}</span>}
        </div>
        <button className="add-btn" onClick={handleSubmit}>
          Update
        </button>
      </div>
    </div>
  );
};

export default EditCategoryPopup;

